import { sanitize } from '@/common/utils/helpers';

export function segmentTypedAnswer(
  typedAnswer: string,
  correctSegments: string[],
): string[] {
  const segmentedAnswer: string[] = [];

  let remainder = typedAnswer;
  for (const correctSegment of correctSegments) {
    let chunks = remainder
      .split(new RegExp(`(${correctSegment})`))
      .filter(Boolean);

    const correctSegmentIndex = chunks.indexOf(correctSegment);
    chunks = [
      chunks.slice(0, correctSegmentIndex).join(''),
      chunks.slice(correctSegmentIndex, correctSegmentIndex + 1).join(''),
      chunks.slice(correctSegmentIndex + 1).join(''),
    ].filter(Boolean);

    for (let i = 0; i < chunks.length; i++) {
      if (i === chunks.length - 1) {
        remainder = chunks[i];
      } else {
        if (chunks.length === 1) remainder = '';
        segmentedAnswer.push(...chunks[i].split(' '));
      }
    }
  }
  if (remainder) segmentedAnswer.push(...remainder.split(' '));

  // Filter out whitespace
  return segmentedAnswer.map((seg) => seg.trim()).filter(Boolean);
}

export function segmentTypedAnswerByWhitespace(typedAnswer: string) {
  return typedAnswer
    .split(' ')
    .map((seg) => sanitize(seg))
    .filter(Boolean);
}

export function validateSegmentedAnswer(
  answerSegments: string[],
  correctSegments: string[],
): boolean[] {
  // return result;
  // First, try to find the correct segments as a (non-consecutive) subsequence of the answer
  const result = new Array(answerSegments.length).fill(false);

  let correctIndex = 0;
  let answerIndex = 0;
  while (
    answerIndex < answerSegments.length &&
    correctIndex < correctSegments.length
  ) {
    if (answerSegments[answerIndex] === correctSegments[correctIndex]) {
      result[answerIndex] = true;
      correctIndex++;
    }
    answerIndex++;
  }
  if (correctIndex === correctSegments.length) {
    return result; // all correct segments found in order
  }

  // Fallback to sequential matching
  result.length = 0; // clear the result
  correctIndex = 0;

  for (const answerSegment of answerSegments) {
    if (
      correctIndex < correctSegments.length &&
      answerSegment === correctSegments[correctIndex]
    ) {
      result.push(true);
      correctIndex++;
    } else {
      result.push(false);
      if (correctIndex < correctSegments.length) {
        correctIndex++;
      }
    }
  }

  return result;
}
